
import React from "react";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import LoginForm from "@/components/auth/LoginForm";
import SignupForm from "@/components/auth/SignupForm";
import ForgotPasswordForm from "@/components/auth/ForgotPasswordForm";
import ResetPasswordForm from "@/components/auth/ResetPasswordForm";
import AuthTabs from "@/components/auth/AuthTabs";
import { useAuthForm } from "@/context/AuthFormContext";

interface AuthFormContainerProps {
  handleLogin: (e: React.FormEvent) => Promise<void>;
  handleSignup: (e: React.FormEvent) => Promise<void>;
  handleGoogleLogin: () => Promise<void>;
}

const AuthFormContainer = ({
  handleLogin,
  handleSignup,
  handleGoogleLogin
}: AuthFormContainerProps) => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    loading,
    googleLoading,
    tab,
    setTab,
    mode,
    setMode
  } = useAuthForm();

  // Render the form based on the current mode
  if (mode === "forgotPassword") {
    return <ForgotPasswordForm />;
  }
  
  if (mode === "resetPassword") {
    return <ResetPasswordForm />;
  }

  // For login/signup modes, render the tabbed interface
  return (
    <Tabs 
      defaultValue={tab} 
      value={tab} 
      onValueChange={(value) => {
        setTab(value as "login" | "signup");
        setMode(value as "login" | "signup");
      }} 
      className="w-full"
    >
      <AuthTabs activeTab={tab} onTabChange={(value) => setTab(value as "login" | "signup")} />
      
      <div className="flex flex-col">
        {tab === "login" && (
          <TabsContent value="login" className="px-0 mt-0">
            <LoginForm
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              loading={loading}
              googleLoading={googleLoading}
              handleLogin={handleLogin}
              handleGoogleLogin={handleGoogleLogin}
            />
          </TabsContent>
        )}
        
        {tab === "signup" && (
          <TabsContent value="signup" className="px-0 mt-0">
            <SignupForm
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              loading={loading}
              googleLoading={googleLoading}
              handleSignup={handleSignup}
              handleGoogleLogin={handleGoogleLogin}
            />
          </TabsContent>
        )}
      </div>
    </Tabs>
  );
};

export default AuthFormContainer;
